<ng-container *ngIf="readOnly; else defaultCementoCheckout">
  <div class="cemento-producto cemento-producto--resume container-fluid py-4">
    <div class="row">
      <div class="col-12 col-lg-5">
        <div class="bg-container-b cemento-producto__resume-summary p-4">
          <div class="color-primary mb-4">
            <h6>Producto</h6>
            <h3>{{ getReadOnlyProductLabel() }}</h3>
          </div>

          <div class="color-primary mb-4">
            <h6>Cantidad</h6>
            <h3>{{ getReadOnlyQuantityLabel() }}</h3>
          </div>

          <div class="color-secondary mb-4">
            <h6>Monto a pagar</h6>
            <h1>{{ getReadOnlyTotalLabel() }}</h1>
          </div>

          <div class="color-primary mb-4">
            <h6>Dirección de despacho</h6>
            <h4>{{ getReadOnlyDispatchAddress() }}</h4>
          </div>

          <div class="color-primary">
            <h6>Fecha de entrega</h6>
            <h4>{{ getReadOnlyDateLabel() }}</h4>
            <h6 *ngIf="getReadOnlyScheduleRange()">{{ getReadOnlyScheduleRange() }}</h6>
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-7 mt-4 mt-lg-0">
        <div class="bg-container-b cemento-producto__resume-payment p-4">
          <h2 class="mb-4">Seleccione medio de pago</h2>

          <div class="alert alert-primary mb-4" role="alert">
            Para garantizar que el pago se procese correctamente, presione <strong>Volver a comercio</strong> al finalizar.
          </div>

          <div class="cemento-producto__payment-options cemento-producto__payment-options--qa">
            <button
              type="button"
              class="cemento-producto__payment-option"
              [class.cemento-producto__payment-option--selected]="selectedPaymentProvider === 'gnet'"
              (click)="selectPaymentProvider('gnet')">
              <img src="assets/img/logos/getnet-logo.svg" alt="getnet-button" class="pago-button img-thumbnail">
            </button>

            <button
              type="button"
              class="cemento-producto__payment-option"
              [class.cemento-producto__payment-option--selected]="selectedPaymentProvider === 'flow'"
              (click)="selectPaymentProvider('flow')">
              <img src="assets/img/logos/flow.svg" alt="flow-button" class="pago-button img-fluid">
            </button>

            <button
              type="button"
              class="cemento-producto__payment-option"
              [class.cemento-producto__payment-option--selected]="selectedPaymentProvider === 'mercadopago'"
              (click)="selectPaymentProvider('mercadopago')">
              <img
                src="assets/img/logos/mercadopago.svg"
                alt="mercadopago-button"
                class="pago-button img-fluid"
              >
            </button>
          </div>

          <div class="cemento-producto__resume-terms d-flex justify-content-center form-check my-3">
            <input
              type="checkbox"
              id="cemento-accept-resume"
              class="form-check-input"
              [(ngModel)]="acceptReadOnlyTerms"
              [ngModelOptions]="{standalone: true}">
            <label class="form-check-label" for="cemento-accept-resume"></label>
            <span class="ps-3">Acepto los términos y condiciones</span>
          </div>

          <div class="text-center cemento-producto__resume-cta">
            <button
              type="button"
              class="btn btn-secondary w-100 p-2 text-uppercase"
              [disabled]="!acceptReadOnlyTerms"
              (click)="continueReadOnlyPayment()">
              continuar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #defaultCementoCheckout>
  <div class="cemento-producto container-fluid py-4">
    <div class="row">
      <aside class="col-12 col-lg-8" aria-label="Secciones del pedido">
        <div class="cemento-producto__accordions bg-container-b p-2 p-sm-3 p-md-4">
          <ng-container *ngIf="flow.currentSection | async as currentSection">
            <app-checkout-accordion-section
              *ngFor="let section of sectionsOrder"
              [title]="sectionTitle(section)"
              [isOpen]="currentSection === section"
              [isCompleted]="sectionHasSavedData(section)"
              [allowToggle]="false"
              [backLinkText]="readOnly ? null : backLabel(section)"
              [continueText]="continueText()"
              [secondaryActionText]="secondaryActionText(section)"
              [canContinue]="getCanContinue(section)"
              [hideContinue]="isAutoAdvanceSection(section) && !sectionHasSavedData(section)"
              [stepNumber]="stepNumber(section)"
              [summaryText]="getSummaryText(section)"
              [isLastStep]="isLastStep(section)"
              (sectionToggle)="flow.openSection(section)"
              (goBack)="onGoBack(section)"
              (secondaryConfirm)="onSecondaryAction(section)"
              (confirm)="onConfirm(section)">
              @if (section === 'producto') {
                <app-cemento-product-section
                  (validChange)="onSectionValidChange('producto', $event)">
                </app-cemento-product-section>
              } @else if (section === 'tipoEntrega') {
                <app-cemento-tipo-entrega-section
                  (validChange)="onSectionValidChange('tipoEntrega', $event)"
                  (selectionChange)="onTipoEntregaSelectionChange($event)">
                </app-cemento-tipo-entrega-section>
              } @else if (section === 'cantidadServicios') {
                <app-cemento-cantidad-servicios-section
                  (validChange)="onSectionValidChange('cantidadServicios', $event)">
                </app-cemento-cantidad-servicios-section>
              } @else if (section === 'fechaServicios') {
                <app-cemento-fecha-servicios-section
                  (validChange)="onSectionValidChange('fechaServicios', $event)">
                </app-cemento-fecha-servicios-section>
              } @else if (section === 'facturacion') {
                <app-cemento-facturacion-section
                  [readOnly]="readOnly"
                  (validChange)="onSectionValidChange('facturacion', $event)"
                  (summaryDraftChange)="onFacturacionSummaryDraft($event)">
                </app-cemento-facturacion-section>
              } @else {
                <p class="color-primary mb-0">Contenido {{ sectionTitle(section) }} - placeholder</p>
              }
            </app-checkout-accordion-section>
          </ng-container>
        </div>
      </aside>
      <aside class="col-12 col-lg-4 mt-4 mt-lg-0" aria-label="Resumen del pedido">
        <div class="cemento-producto__sidebar-sticky">
          <app-order-summary-sidebar
            [items]="(summaryItems$ | async) ?? []">
          </app-order-summary-sidebar>
        </div>
      </aside>
    </div>
  </div>
</ng-template>

<ng-template #paymentModal let-modal>
  <div class="modal-header payment-selector__header">
    <h4 class="modal-title text-uppercase payment-selector__title">
      <img class="payment-selector__brand" src="assets/img/logo.svg" alt="Cbb Store">
      Seleccione medio de pago
    </h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body payment-selector__body">
    <div class="col-12">
      <div class="alert alert-primary alert-dismissible fade show payment-selector__alert" role="alert">
        Para garantizar que el pago se procese correctamente, presione el botón
        <strong>Volver a comercio</strong> al finalizar.
      </div>
    </div>
    <div class="col text-center" *ngFor="let provider of paymentProviders">
      <button
        type="button"
        class="payment-selector__option"
        [class.payment-selector__option--selected]="selectedPaymentProvider === provider.id"
        [attr.aria-pressed]="selectedPaymentProvider === provider.id"
        (click)="selectAndStartPayment(provider.id)">
        <img [src]="provider.logo" [alt]="provider.name" class="pago-button">
        <span class="payment-selector__description">{{ provider.description }}</span>
      </button>
    </div>
  </div>
</ng-template>
